export default {
  'eventEngine.title': 'Event Engine',
  'eventEngine.subTitle':
    'Inspect platform event traffic, subscriptions and per-consumer delivery results',
  'eventEngine.forbidden.title': 'Event engine access denied',
  'eventEngine.forbidden.subTitle':
    'This view shows platform events across tenants and is limited to tenant administrators. Contact an administrator for access.',

  'eventEngine.tab.events': 'Events',
  'eventEngine.tab.consumptions': 'Consumption records',
  'eventEngine.tab.subscriptions': 'Subscriptions',

  'eventEngine.stat.totalEvents': 'Total events',
  'eventEngine.stat.pendingEvents': 'Pending dispatch',
  'eventEngine.stat.failedConsumptions': 'Failed and dead-lettered',
  'eventEngine.stat.activeSubscriptions': 'Active subscriptions',

  'eventEngine.field.type': 'Event type',
  'eventEngine.field.status': 'Status',
  'eventEngine.field.source': 'Source service',
  'eventEngine.field.subject': 'Subject',
  'eventEngine.field.tenantId': 'Tenant',
  'eventEngine.field.appId': 'Application',
  'eventEngine.field.operatorId': 'Operator',
  'eventEngine.field.eventversion': 'Event version',
  'eventEngine.field.ceId': 'Event ID',
  'eventEngine.field.consumer': 'Consumer',
  'eventEngine.field.pattern': 'Pattern',
  'eventEngine.field.serviceName': 'Service',
  'eventEngine.field.callbackUrl': 'Callback URL',
  'eventEngine.field.retryCount': 'Retries',
  'eventEngine.field.lastError': 'Last error',
  'eventEngine.field.nextRetryAt': 'Next retry at',
  'eventEngine.field.consumedAt': 'Consumed at',
  'eventEngine.field.failedAt': 'Failed at',
  'eventEngine.field.deadAt': 'Dead-lettered at',
  'eventEngine.field.publishedAt': 'Dispatched at',
  'eventEngine.field.time': 'Occurred at',
  'eventEngine.field.occurredAt': 'Occurred at',
  'eventEngine.field.recordedAt': 'Recorded at',
  'eventEngine.field.createdAt': 'Created at',
  'eventEngine.field.updatedAt': 'Updated at',
  'eventEngine.field.action': 'Action',
  'eventEngine.field.unknown': 'Unknown',

  'eventEngine.placeholder.typePrefix': 'Prefix match, e.g. tenant.',
  'eventEngine.placeholder.pattern': 'e.g. tenant.# or member.*',
  'eventEngine.placeholder.source': 'All source services',

  'eventEngine.action.detail': 'Details',
  'eventEngine.detail.eventTitle': 'Event details',
  'eventEngine.detail.consumptionTitle': 'Consumption record details',
  'eventEngine.detail.payload': 'Payload',
  'eventEngine.detail.rawEvent': 'Full record',
  'eventEngine.detail.copyJson': 'Copy JSON',
  'eventEngine.detail.copied': 'Copied',
  'eventEngine.detail.emptyPayload': 'This event carries no payload',
  'eventEngine.detail.lastError': 'Last error',

  'eventEngine.outboxStatus.pending': 'Pending',
  'eventEngine.outboxStatus.published': 'Dispatched',
  'eventEngine.outboxStatus.failed': 'Dispatch failed',

  'eventEngine.inboxStatus.processing': 'Delivering',
  'eventEngine.inboxStatus.consumed': 'Consumed',
  'eventEngine.inboxStatus.failed': 'Awaiting retry',
  'eventEngine.inboxStatus.dead': 'Dead letter',

  'eventEngine.subscriptionStatus.active': 'Active',
  'eventEngine.subscriptionStatus.disabled': 'Disabled',

  'eventEngine.action.retry': 'Retry',
  'eventEngine.retry.singleTitle': 'Retry this record?',
  'eventEngine.retry.singleConsumptionDesc':
    'The record will be queued for redelivery. Already-consumed events are skipped.',
  'eventEngine.retry.singleEventDesc':
    'The event will be republished to the queue. Duplicates are de-duplicated downstream.',
  'eventEngine.retry.batchAction': 'Retry all matching',
  'eventEngine.retry.batchTitle': 'Retry all matching records?',
  'eventEngine.retry.batchContent':
    'The current filter matches {count} records. Only those in a retryable state are re-queued; the rest are left untouched. This cannot be undone.',
  'eventEngine.retry.confirm': 'Retry',
  'eventEngine.retry.cancel': 'Cancel',
  'eventEngine.retry.success': 'Re-queued {count} records',

  'eventEngine.preset.last1Hour': 'Last 1 hour',
  'eventEngine.preset.today': 'Today',
  'eventEngine.preset.last24Hours': 'Last 24 hours',
  'eventEngine.preset.last3Days': 'Last 3 days',
  'eventEngine.preset.last7Days': 'Last 7 days',

  'eventEngine.action.viewConsumptions': 'View consumptions',
  'eventEngine.action.viewSourceEvent': 'View source event',
  'eventEngine.action.retrySelected': 'Retry selected ({count})',
  'eventEngine.retry.selectedTitle': 'Retry selected records?',
  'eventEngine.retry.selectedContent':
    '{count} selected records will be retried. Already-consumed events are skipped.',
  'eventEngine.retry.selectedSuccess':
    'Batch retry completed: {success} succeeded, {failed} failed',
  'eventEngine.retry.notRetryable': 'Current status cannot be retried',
  'eventEngine.retry.inDrawerAction': 'Retry this record',

  'eventEngine.refresh.title': 'Refresh statistics',
  'eventEngine.refresh.lastUpdated': 'Updated at {time}',
  'eventEngine.refresh.autoRefresh': 'Auto refresh',
  'eventEngine.refresh.off': 'Off',
  'eventEngine.refresh.30s': '30s',
  'eventEngine.refresh.60s': '60s',

  'eventEngine.detail.searchPayload': 'Search in payload...',
  'eventEngine.detail.downloadJson': 'Download JSON',
  'eventEngine.detail.wrapLines': 'Wrap lines',
  'eventEngine.detail.expandError': 'Expand error details',
  'eventEngine.detail.collapseError': 'Collapse error details',
  'eventEngine.stat.cardTip': 'Click to filter by this status',

  'eventEngine.action.delete': 'Delete',
  'eventEngine.subscription.deleteTitle': 'Delete this subscription?',
  'eventEngine.subscription.deleteDesc':
    'The consumer will stop receiving events. Subscriptions are auto-registered at service startup, so a running service will re-register on its next restart. Pending consumption records are dead-lettered on their next retry.',
  'eventEngine.subscription.confirm': 'Delete',
  'eventEngine.subscription.deleted': 'Subscription deleted',
  'eventEngine.subscription.deleteMissing':
    'That subscription no longer exists; the list has been refreshed',

  'eventEngine.delete.singleTitle': 'Delete this dead letter?',
  'eventEngine.delete.singleDesc':
    'The record is permanently removed and the event will never be redelivered to this consumer. Only dead-lettered records can be deleted.',
  'eventEngine.delete.batchAction': 'Delete dead letters',
  'eventEngine.delete.batchTitle': 'Delete all matching dead letters?',
  'eventEngine.delete.batchContent':
    'The current filter matches {count} records. Those in the dead-letter state are permanently removed; the rest are left untouched. Those events will never be redelivered. This cannot be undone.',
  'eventEngine.delete.confirm': 'Delete',
  'eventEngine.delete.success': 'Deleted {count} dead letters',
};
